import { formatDate, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  calculateTimeDifference,
  getFormattedDate,
  getFormattedTime,
  getStartAndEndTime,
  getWelfareCheckInterval,
  isLargeScreen,
} from '../../../../../../global.variable';
import { AppService } from '../../../../../app.service';
import { UserProfileService } from '../../../../../profile/user-profile/user-profile.service';
import { AddEditSiteComponent } from '../../../../../shared/components/add-edit-site/add-edit-site.component';
import { CompanyLicencePromptComponent } from '../../../../../shared/components/company-licence-prompt/company-licence-prompt.component';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../../../../../shared/components/view-user-detail/view-user-detail.component';
import { DataCheckService } from '../../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { ClientsService } from '../../../clients/clients.service';
import { UsersService } from '../../../users/users.service';
import { JobsService } from '../../jobs.service';
@Component({
  selector: 'gtapp-other',
  templateUrl: './other.component.html',
  styleUrl: './other.component.scss',
  standalone: false,
})
export class OtherComponent implements OnInit {
  @Input() selectedJobType: any;

  formdata = new UntypedFormGroup({
    clientName: new UntypedFormControl('', Validators.required),
    siteName: new UntypedFormControl('', Validators.required),
    siteContactName: new UntypedFormControl(''),
    assigneeName: new UntypedFormControl(),
    requestDetail: new UntypedFormControl(),
    internal_notes: new UntypedFormControl(),
    position: new UntypedFormControl(),
    externalJobId: new UntypedFormControl(),
  });

  isAdmin: boolean = this.dataCheckService.isUserAdmin();

  siteLicenceReminderCheck: boolean = false;
  licenseReminderField: boolean = false;

  addJobPressed: boolean = false;
  scheduleStepperActive: boolean = false;

  otherJobType: any = {
    jobType: {
      name: 'job Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    client: {
      name: 'Client',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    site: { name: 'Site', value: '', edit: false, data: null, tempValue: '' },
    assignee: {
      name: 'Assignee',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    ai: {
      name: 'Additional Information',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    in: {
      name: 'Internal Notes',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    oc: {
      name: 'On Site Contact',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    schedule: {
      name: 'Schedule',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    st: {
      name: 'Service Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
  };

  siteList: any = [];

  assigneeList: any = [];
  initalAssigneeListData: any = [];
  initalsiteListData: any = [];
  initalServiceTypeListData: any = [];

  companyLicenseStateList: any = [];

  dialogRef: any;
  userData: any;

  intervalData: any = [{ name: 'Disabled', value: 0 }];
  intervalCheck: any = 0;
  welfareReminderDict: any = {};
  additionalInfo: any = { geofence_distance: 500 };

  schedulerForm: UntypedFormGroup = new UntypedFormGroup({
    end_time: new FormControl(null),
    start_time: new FormControl(null),
    start_day: new FormControl(new Date()),
    end_day: new FormControl(null, Validators.required),

    repeat_times: new UntypedFormControl(null),
    repeat_type: new UntypedFormControl(null, Validators.required),
    repeat_details: new UntypedFormControl([]),
    repeat_interval: new UntypedFormControl(1, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    position: new UntypedFormControl(null, []),
    week_day: new UntypedFormControl(null, []),
    month_repeat_case: new UntypedFormControl(null, []),
  });
  addSchedule: boolean = false;
  currentStep: number = 1;

  largeView = isLargeScreen;

  enableGeofencing: boolean = false;

  serviceTypeListData: any = [];

  selectedSiteExtraDetails: any;

  userDetailPopoverTemplate = ViewUserDetailComponent;

  validAssigneeCheckDict: any = {};

  subscriberUserId =
    this.appService.getUserData()?.subscriber?.subscriber_user_id;

  selectedSuggestedShift: any = {};
  constructor(
    private cdr: ChangeDetectorRef,
    private jobService: JobsService,
    private profileService: UserProfileService,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private appService: AppService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private userService: UsersService,
    private _location: Location,
  ) {
    this.userData = this.appService.getUserData();

    this.siteLicenceReminderCheck = this.userData?.checks?.license_reminder;
  }
  ngOnDestroy() {
    sessionStorage.removeItem('schedulerData');
  }

  ngOnInit(): void {
    const rosterCopyJobInfo = JSON.parse(
      sessionStorage.getItem(btoa('rosterCopyJobInfo')) || '{}',
    );
    if (
      rosterCopyJobInfo?.id &&
      rosterCopyJobInfo?.job_type_dict?.id == this.selectedJobType?.id
    ) {
      this.loadSuggestedShift(rosterCopyJobInfo);
    } else {
      if (this.selectedJobType?.type_identity === 1) {
        this.shiftFocus('stId');
      } else {
        this.shiftFocus('siteId');
      }
      if (this.siteLicenceReminderCheck && this.isAdmin) {
        this.getCompanyLicenses();
      }
    }
    sessionStorage.removeItem(btoa('rosterCopyJobInfo'));
    this.otherJobType.jobType.value = this.selectedJobType?.name;
    this.otherJobType.jobType.data = this.selectedJobType;

    this.onSiteSearch('');
    this.getServiceTypes();
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }

  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';
    this.otherJobType.site.tempValue = searchString;

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteList = res?.data?.splice(0, 10);
          if (!searchString) {
            this.initalsiteListData = JSON.parse(JSON.stringify(this.siteList));
          }
        }
      });
  }
  doSiteLicenseCheck() {
    const stateCode = this.selectedSiteExtraDetails?.state_code?.toLowerCase();
    const stateName = this.selectedSiteExtraDetails?.state_name?.toLowerCase();

    const stateCompanyLicencePresent = this.companyLicenseStateList.some(
      (i: any) =>
        i?.toLowerCase() == stateCode || i?.toLowerCase() == stateName,
    );

    if (stateCompanyLicencePresent) {
      this.shiftFocus('assigneeId');
    } else {
      const dialogRef = this.dialogService.open(
        CompanyLicencePromptComponent,
        {
          data: { credentialState: stateName || stateCode },
        },
        this.viewContainerRef,
      );
      dialogRef.afterClosed().subscribe((res: any) => {
        this.siteLicenceReminderCheck = false;
        this.shiftFocus('assigneeId');
      });
    }
  }

  async onSelectSite(data: any) {
    if (data?.key === 0) {
      this.openAddSiteForm();
    }

    if (data?.id) {
      this.selectedSiteExtraDetails = {};
      this.validAssigneeCheckDict = {};
      this.otherJobType.site.value = data?.company_name;
      this.otherJobType.site.data = data;
      this.formdata.controls['siteName'].setValue(data?.company_name);
      if (data?.company) {
        this.otherJobType.client.value = data?.company?.company_name;
        this.otherJobType.client.data = data?.company;
        this.formdata.controls['clientName'].setValue(
          data?.company?.company_name,
        );
      }

      this.getSiteDetailById(data?.id);
      this.findSelectedSiteAddInfo(data?.id);

      this.currentStep = 2;
      this.updateInitialDataList();
    }
  }
  findSelectedSiteAddInfo(siteId: string) {
    this.jobService
      .fetchJobDetails(
        { site_id: siteId, job_type_id: this.selectedJobType?.id },
        { get_last_assignees: 1, additional_site_info: 1 },
      )
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSiteExtraDetails = {
            ...this.selectedSiteExtraDetails,
            ...response?.data,
          };
          this.getAssignees();
        } else {
          this.getAssignees();
        }
      });
  }

  getSiteDetailById(siteId: any) {
    this.spinnerService.show('Fetching Site Information');
    let siteFields = ['state_name', 'state_code'];
    // getting site information for static guards
    if (this.selectedJobType?.type_identity === 2)
      siteFields.push('information');

    this.clientService
      .getSiteDetailsById(siteId, {
        get_details: 1,
        site_fields: JSON.stringify(siteFields),
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSiteExtraDetails = {
            ...this.selectedSiteExtraDetails,
            ...response?.data,
          };
          if (this.siteLicenceReminderCheck && this.isAdmin == true) {
            this.doSiteLicenseCheck();
          } else {
            this.shiftFocus('assigneeId');
          }
        }
        this.spinnerService.hide();
      });
  }

  openAddSiteForm() {
    const dialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: { company_name: this.otherJobType.site.tempValue },
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.onSelectSite(value);
      }
    });
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.updateInitialDataList();
    }
  }

  updateInitialDataList() {
    setTimeout(() => {
      this.siteList = JSON.parse(JSON.stringify(this.initalsiteListData));
      this.serviceTypeListData = JSON.parse(
        JSON.stringify(this.initalServiceTypeListData),
      );
      this.assigneeList = JSON.parse(
        JSON.stringify(this.initalAssigneeListData),
      );

      this.cdr.detectChanges();
    }, 200);
  }
  getAssignees(params?: any) {
    const reqParams = params || {};

    let reqBody: any = {};

    if (this.selectedSiteExtraDetails?.last_assignees) {
      const assigneeIds = Object.keys(
        this.selectedSiteExtraDetails?.last_assignees || {},
      );

      if (assigneeIds?.length)
        reqBody.sort_assignee_ids = assigneeIds?.slice(0, 5);
    }
    if (this.selectedSiteExtraDetails?.preferred_user_ids) {
      const assigneeIds =
        this.selectedSiteExtraDetails?.preferred_user_ids || [];

      if (assigneeIds?.length) reqBody.preferred_user_ids = assigneeIds;
    }
    this.jobService
      .getUserList(reqParams, reqBody)
      .subscribe(async (response: any) => {
        if (response['status'] == 'success') {
          const paramsPresent = params && Object.keys(params)?.length;

          if (!paramsPresent) {
            this.initalAssigneeListData = JSON.parse(
              JSON.stringify(response?.data),
            );
          }
          setTimeout(() => {
            this.assigneeList = JSON.parse(JSON.stringify(response?.data));
            this.cdr.detectChanges();
          }, 50);
        }
      });
  }
  async checkValidCredentialsForAssignee(assigneeId: string) {
    return new Promise((resovle) => {
      this.spinnerService.show('Checking Guard Credentials');

      const stateCode =
        this.selectedSiteExtraDetails?.state_code?.toLowerCase();
      const stateName =
        this.selectedSiteExtraDetails?.state_name?.toLowerCase();

      let stateArrays = [];

      if (stateCode)
        stateArrays.push(stateCode?.toLowerCase(), stateCode?.toUpperCase());
      if (stateName)
        stateArrays.push(stateName?.toLowerCase(), stateName?.toUpperCase());
      stateArrays = [...new Set(stateArrays)];
      if (stateArrays?.length) {
        this.userService
          .getUserById(assigneeId, {
            valid_cred_check: 1,
            states: JSON.stringify(stateArrays),
          })
          .subscribe((response: any) => {
            resovle(response?.data || false);
            this.spinnerService.hide();
          });
      } else {
        resovle(true);
      }
    });
  }

  async onAssigneeSelect(assignee: any) {
    if (assignee?.id) {
      this.otherJobType.assignee.value = assignee?.full_name;
      this.otherJobType.assignee.data = assignee;
      this.formdata.controls['assigneeName'].setValue(assignee?.full_name);

      let validAssignee: any = false;

      if (assignee?.id in this.validAssigneeCheckDict) {
        validAssignee = this.validAssigneeCheckDict[assignee?.id];
      } else {
        validAssignee = await this.checkValidCredentialsForAssignee(
          assignee?.id,
        );
      }

      this.validAssigneeCheckDict[assignee?.id] = validAssignee;

      if (validAssignee) {
        this.currentStep = 3;
        this.shiftFocus('aiId');
      } else {
        let dialogMsg;
        if (this.userData.profile.email === assignee.email) {
          dialogMsg =
            'You may not hold the requried credentials (e.g. Security Licence, Police Checks, etc...) for this job. You can upload your credentials under your profile settings, or ignore this message.';
        } else {
          dialogMsg = `${
            assignee.full_name || assignee.email
          } may not hold the appropriate credentials (e.g. Security Licence) for this job. Ignore?`;
        }
        this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Job Assignment',
            message: dialogMsg,
          },
        });
        this.dialogRef.afterClosed().subscribe((value: any) => {
          if (value === true) {
            this.otherJobType.assignee.value = assignee?.full_name;
            this.otherJobType.assignee.data = assignee;
            this.formdata.controls['assigneeName'].setValue(
              assignee?.full_name,
            );
            this.currentStep = 3;
            this.shiftFocus('aiId');
          } else {
            this.editField('assignee');
          }
        });
      }
    }
  }

  onAddJob() {
    this.addJobPressed = true;
    this.spinnerService.show();
    let data: any = {
      job_type_id: this.selectedJobType.id,
      service_type_id: this.otherJobType?.st?.data?.id,
      company_id: this.otherJobType?.client?.data?.id,
      location: [this.otherJobType?.site?.data?.id],
      is_abandoned: false,
      request: this.formdata.value.requestDetail,
      internal_notes: this.formdata.value.internal_notes,
      position: this.formdata.value.position,
      external_job_id: this.formdata.value.externalJobId,
      new_assignee: this.otherJobType?.assignee?.data?.id,
      location_contact_id: this.otherJobType?.oc?.data?.id,
    };
    let params: any = {};
    if (this.addSchedule) {
      data['interval_check'] = this.intervalCheck;
      data['additional_info'] = this.additionalInfo;

      this.schedulerForm.value.start_day =
        this.schedulerForm.value.start_day == ''
          ? ''
          : formatDate(this.schedulerForm.value.start_day, 'yyyy-MM-dd', 'en');
      this.schedulerForm.value.end_day =
        this.schedulerForm.value.end_day == null
          ? null
          : formatDate(this.schedulerForm.value.end_day, 'yyyy-MM-dd', 'en');
      let timezoneOffset = new Date();
      params.save_schedule = 1;
      data = {
        time_offset: timezoneOffset.getTimezoneOffset(),
        ...this.schedulerForm.value,
        ...data,
      };
    }
    this.jobService
      .createJob(data, params)
      .then((res: any) => {
        if (res['status'] == 'success') {
          this._location.back();
        } else {
          this.addJobPressed = false;
          this.toasterService.setMessage({
            errorMessage: res['message'],
            successMessage: '',
          });
          this.spinnerService.hide();
        }
      })
      .catch((error: any) => {
        if (error) {
          this.addJobPressed = false;
        }
      });
  }

  getCompanyLicenses() {
    let params = { credential_check: 1 };
    this.profileService
      .fetchCompanyDetails(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userData['checks']['license_reminder'] =
            response?.data?.license_reminder;
          this.siteLicenceReminderCheck = response?.data?.license_reminder;
          this.appService.setUserData(this.userData);
          this.companyLicenseStateList =
            response?.data?.credential_states || [];
        }
      });
  }

  updateInterval(interval: any) {
    this.intervalCheck = interval;
  }

  getIntervalData() {
    const scheduleData: any = JSON.parse(
      JSON.stringify(this.schedulerForm.value),
    );
    let diffValue = calculateTimeDifference(scheduleData);

    [this.intervalData, this.welfareReminderDict] =
      getWelfareCheckInterval(diffValue);
    if (!this.intervalData?.length) {
      this.intervalData = [{ name: 'Disabled', value: 0 }];
    }
  }
  updateMinDistance(event: any) {
    this.additionalInfo.geofence_distance = event;
  }
  onSTSearch(event: any) {
    this.otherJobType.st.tempValue = event.target.value;

    if (event.target.value.length) {
      this.serviceTypeListData = this.initalServiceTypeListData?.filter(
        (type: any) =>
          type?.name
            ?.toLowerCase()
            ?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.serviceTypeListData = this.initalServiceTypeListData;
    }
  }

  getServiceTypes(params?: any) {
    this.clientService.fetchServiceTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.serviceTypeListData = res['data'];

        this.initalServiceTypeListData = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onServiceTypeSelect(responseType: any) {
    if (responseType.key === 0) {
      this.openAddServiceType();
    }
    if (responseType?.id) {
      this.otherJobType.st.value = responseType?.name;
      this.otherJobType.st.data = responseType;
      this.blurTriggered('st');
      this.shiftFocus('siteId');
    }
  }
  openAddServiceType() {
    if (this.otherJobType.st.tempValue?.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createServiceType({ name: String(this.otherJobType.st.tempValue) })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onServiceTypeSelect(response?.data);
            this.toasterService.setMessage({
              errorMessage: '',
              successMessage: response['message'],
            });
            this.getServiceTypes();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Service Type value can't be empty",
        successMessage: '',
      });
    }
  }
  editField(field: string) {
    if (field == 'site') {
      this.otherJobType.site.search = true;
      this.otherJobType.site = {
        name: 'Site',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.otherJobType.client = {
        name: 'Client',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };

      this.formdata.controls['clientName'].setValue(null);
      this.formdata.controls['siteName'].setValue(null);

      this.shiftFocus('siteId');
    }
    if (field == 'assignee') {
      this.otherJobType.assignee = {
        name: 'Assignee',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.formdata.controls['assigneeName'].setValue(null);

      this.shiftFocus('assigneeId');
    }
    if (field == 'st') {
      this.otherJobType.st = {
        name: 'Service Type',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };

      this.shiftFocus('stId');
    }
    this.updateInitialDataList();
  }
  blurTriggered(field: string) {
    if (field === 'site') {
      this.otherJobType.site.search = !Boolean(this.otherJobType.site.data?.id);
    }
    if (field === 'assignee') {
      this.otherJobType.assignee.search = !Boolean(
        this.otherJobType.assignee.data?.id,
      );
    }
    if (field === 'st') {
      this.otherJobType.st.search = !Boolean(this.otherJobType.st.data?.id);
    }
  }
  loadSuggestedShift(shiftData: any) {
    this.spinnerService.show();
    this.jobService
      .loadSuggestedShift({ job_id: shiftData?.id })
      .then((response: any) => {
        if (response?.status == 'success') {
          this.selectedSuggestedShift = response?.data;
          const siteInfo = response?.data?.site;
          if (siteInfo?.id) {
            this.selectedSiteExtraDetails = {};
            this.validAssigneeCheckDict = {};
            this.otherJobType.site.value = siteInfo?.company_name;
            this.otherJobType.site.data = siteInfo;
            this.formdata.controls['siteName'].setValue(siteInfo?.company_name);

            this.getSiteDetailById(siteInfo?.id);
            this.findSelectedSiteAddInfo(siteInfo?.id);
          }

          const clientInfo = response?.data?.company;
          if (clientInfo?.id) {
            this.otherJobType.client.value = clientInfo?.company_name;
            this.otherJobType.client.data = clientInfo;
            this.formdata.controls['clientName'].setValue(
              clientInfo?.company_name,
            );
          }
          const assigneeInfo = response?.data?.assignee;
          if (assigneeInfo?.id) {
            this.otherJobType.assignee.value = assigneeInfo?.full_name;
            this.otherJobType.assignee.data = assigneeInfo;
            this.formdata.controls['assigneeName'].setValue(
              assigneeInfo?.full_name,
            );
          }
          const serviceTypeInfo = response?.data?.service_type;
          if (serviceTypeInfo?.id) {
            this.otherJobType.st.value = serviceTypeInfo?.name;
            this.otherJobType.st.data = serviceTypeInfo;
          }
          this.otherJobType.ai.value = response?.data?.additional_info;
          this.otherJobType.in.value = response?.data?.internal_notes;
          this.formdata.controls['position'].setValue(
            response?.data?.position || '',
          );
          this.intervalCheck = response?.data?.interval_check;
          this.formatScheduleForm();
          this.currentStep = 5;

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  formatScheduleForm() {
    this.addSchedule = true;
    const currentSchedule = sessionStorage.getItem(btoa('currentSchedule'));

    if (currentSchedule) {
      this.schedulerForm.patchValue(JSON.parse(currentSchedule));
      this.scheduleStepperActive = true;
      sessionStorage.removeItem(btoa('currentSchedule'));

      return;
    }

    const passedDateFromSession = sessionStorage.getItem('selectedRosterDate');
    const passedDate = passedDateFromSession
      ? new Date(passedDateFromSession)
      : new Date();

    passedDate.setHours(9, 55, 0, 0);

    let [startDateTime, endDateTime] = getStartAndEndTime(passedDate);

    if (this.selectedSuggestedShift?.roster_scheduler?.end_time) {
      // take schedule from the prefilled info
      const preFillSchedule = this.selectedSuggestedShift?.roster_scheduler;

      startDateTime = new Date(
        (this.selectedSuggestedShift?.event_date ||
          preFillSchedule?.start_day) +
          ' ' +
          preFillSchedule?.start_time,
      );

      // check start time is greater than midnight today
      const todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);

      if (startDateTime < todayMidnight) {
        const startDateTimeCopy = new Date(startDateTime);
        startDateTime = new Date();
        startDateTime.setHours(
          startDateTimeCopy.getHours(),
          startDateTimeCopy.getMinutes(),
          0,
          0,
        );
      }

      endDateTime = new Date(
        (this.selectedSuggestedShift?.event_date || preFillSchedule?.end_day) +
          ' ' +
          preFillSchedule?.end_time,
      );

      if (endDateTime.getTime() < startDateTime.getTime()) {
        // end time less than start time
        const endDateBackup = new Date(endDateTime);
        endDateTime = new Date();
        endDateTime.setHours(
          endDateBackup.getHours(),
          endDateBackup.getMinutes(),
          0,
          0,
        );
      }
      if (endDateTime.getTime() < startDateTime.getTime()) {
        // overnight cases
        endDateTime.setDate(startDateTime.getDate() + 1);
      }
      if (endDateTime.getTime() < new Date().getTime()) {
        // start and end times have expired for the current day
        endDateTime.setDate(new Date().getDate() + 1);
        startDateTime.setDate(new Date().getDate() + 1);
      }
    }

    this.schedulerForm.controls['repeat_type'].setValue('once');
    this.schedulerForm.controls['end_day'].setValue(
      getFormattedDate(endDateTime),
    );
    this.schedulerForm.controls['end_time'].setValue(
      getFormattedTime(endDateTime),
    );
    this.schedulerForm.controls['end_day'].updateValueAndValidity();
    this.schedulerForm.controls['end_day'].clearAsyncValidators();
    this.schedulerForm.controls['start_day'].setValue(
      getFormattedDate(startDateTime),
    );
    this.schedulerForm.controls['start_time'].setValue(
      getFormattedTime(startDateTime),
    );

    sessionStorage.removeItem('selectedRosterDate');

    this.scheduleStepperActive = true;

    this.getIntervalData();
  }
  saveCurrentSchedule() {
    sessionStorage.setItem(
      btoa('currentSchedule'),
      JSON.stringify(this.schedulerForm.value),
    );
  }
}
